/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useRef, useState } from 'react';
import { useThemeMode } from '../../../../_metronic/partials';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../modules/auth';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../global/store';
import request from '../../../../utils/request';
import { useDispatch } from 'react-redux';
import { updateCustomerDashboard } from '../../../../global/features/dashboardSlice';
import { currencyFormat } from '../../../../utils';
import { enAU } from 'date-fns/locale';
import moment from 'moment';
import getSelectedDate from '../utils/getSelectedDate';
moment.updateLocale(moment.locale('en', enAU), { invalidDate: '-' });
// import {KTIcon} from '../../../../helpers'
// import {getCSSVariableValue} from '../../../../assets/ts/_utils'
// import {useThemeMode} from '../../../layout/theme-mode/ThemeModeProvider'

type Props = {
	className: string;
	chartSize?: number;
	chartLine?: number;
	chartRotate?: number;
	statusColor?: string;
	setstatusColor?: any;
	lastDate?: string;
	setLastUnit?: any;
};

const MainChart: FC<Props> = ({
	className,
	chartSize = 215,
	chartLine = 28,
	chartRotate = 0,
	statusColor = '',
	setstatusColor = {},
	lastDate = '',
	setLastUnit = {},
}) => {
	const { currentUser } = useAuth();
	const { mode } = useThemeMode();
	const dispatch = useDispatch();
	const chartRef = useRef<HTMLDivElement | null>(null);
	const [searchParams] = useSearchParams();

	let custNum = localStorage.getItem('customerNum');


	const dataCapel = useSelector((v: RootState) => v.customerReducer.identify);
	const customerDashboard: any = useSelector(
		(val: RootState) => val.dashboardReducer.customerDashboard
	);


	const [isLargeScreen, setIsLargeScreen] = useState(
		window.matchMedia('(min-width: 992px)').matches
	);
	// const [statusColor, setstatusColor] = useState('badge-light-secondary')
	const [loading, setLoading] = useState(false);
	const [uomPeriodLabel, setUomPeriodLabel] = useState("month");


	const _getSelectedDate = () => {
		return getSelectedDate(searchParams.get('date'));
	};
	const renderUnit = (unit: string) => {
		if (unit.includes('M3') || unit === 'm³' || unit.includes('<sup>')) {
			return 'm³';
		} else {
			return customerDashboard.unit;
		}
	};
	const GetCustomerDashboard = async () => {
		if (!lastDate || lastDate === '') return;
		const payload: any = {
			CustomerNumber: custNum,
			// CustomerNumber: '034774895',
			FromDate: customerDashboard?.measureStartDate || _getSelectedDate().fromDate,
			// ToDate: lastDate != '' ? moment(lastDate).format('YYYY-MM-DD') : _getSelectedDate().toDate,
			ToDate: moment(lastDate).format('YYYY-MM-DD'),
		};
		await request
			.post(`dashboard/GetCustomerDashboard`, payload)
			.then((res) => {
				setLoading(false);
				if (res?.status === 200 || res?.status === 201) {
					const data = res.data;
					// const data = {
					// 	latestUsage: 426.096,
					// 	estimateUsage: 7243.632,
					// 	minimumContract: 2198,
					// 	maximumContract: 2637,
					// 	percentage: 16.158361,
					// 	unit: 'MMBtu',
					// 	usageType: 'Below',
					// 	error: '',
					// };
					if (data) {
						statusColor = 'badge-light-warning';
						// if(data.usageType === 'Below') {
						//      statusColor = 'badge-light-warning';
						// } else
						if (data.usageType === 'Above') {
							statusColor = 'badge-light-danger';
						} else if (data.usageType === 'InRange') {
							statusColor = 'badge-light-success';
						}
						setstatusColor(statusColor);
						dispatch(updateCustomerDashboard(data));
						if (data.unit) {
							if (
								data.unit.includes('M3') ||
								data.unit === 'm³' ||
								data.unit.includes('<sup>')
							) {
								setLastUnit(`m³`);
							} else {
								setLastUnit(data.unit);
							}
						}
						return refreshChart(data);
					}
				} else {
					console.log('DATA IS EMPTY');
				}
				dispatch(
					updateCustomerDashboard({
						latestUsage: 0,
						estimateUsage: 0,
						minimumContract: 0,
						maximumContract: 0,
						percentage: 0,
						unit: 'MMBtu',
						usageType: '',
						error: '',
						measureStartDate: '',
						measureEndDate: ''
					})
				);
				refreshChart();
			});
	};
	const refreshChart = (data?: any) => {
		if (!chartRef.current) {
			return;
		}

		setTimeout(() => {
			initChart(chartSize, chartLine, chartRotate, statusColor, data);
		}, 10);
	};


	useEffect(() => {
		if (lastDate != '' || !lastDate) {
			setLoading(true);
			GetCustomerDashboard();
		}
		// refreshChart()

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [lastDate]);
	useEffect(() => {
		const handleResize = () => {
			setIsLargeScreen(window.matchMedia('(min-width: 992px)').matches);
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);
	useEffect(() => {
		setUomPeriodLabel(customerDashboard?.uom?.toLowerCase().includes('tahun') ? 'year' : customerDashboard?.uom?.toLowerCase().includes('bulan') ?
			'month' : customerDashboard?.uom?.toLowerCase().includes('hari') ? 'day' : 'month');
	}, [customerDashboard?.uom]);

	useEffect(() => {
		const parsedDate = {
			...customerDashboard,
			measureStartDate: customerDashboard?.measureStartDate.replace(/\./g, ':'),
			measureEndDate: customerDashboard?.measureEndDate.replace(/\./g, ':')
		}

		dispatch(updateCustomerDashboard(parsedDate))
	}, [customerDashboard?.measureStartDate, customerDashboard?.measureEndDate])

	return (
		<div className={`card ${className}`}>
			<div style={{ height: '100px' }} className="card-header border-2">
				<h3 className="card-title align-items-center d-flex w-100">
					<div className="d-flex w-100 align-items-start flex-wrap">
						<div className="d-xl-block d-none w-50">
							<span className="card-label fw-bold fs-3 mb-3">
								Usage summary
							</span>
						</div>
						<div className="d-xl-none w-100">
							<div className="fs-4 fw-bold align-self-start w-100 text-muted text-overflow-two">
								{dataCapel?.cust_name_decrypt}
							</div>
						</div>

						<div className="d-xl-none mt-3 w-100"></div>

						<div className="d-flex justify-content-end w-100 flex-column flex-end">
							<div
								className={`badge pointer d-flex justify-content-center w-125px ${statusColor} fs-base`}
							>
								{statusColor == 'badge-light-warning'
									? 'Below contract'
									: statusColor == 'badge-light-success'
										? 'In range'
										: 'Above contract'}
							</div>
							<div className="fs-8 mt-1">
								{customerDashboard?.uom?.toLowerCase()?.includes("hari")
									? moment(customerDashboard?.measureEndDate).format('DD MMM YYYY')
									: `${moment(customerDashboard?.measureStartDate).format('DD MMM YYYY')} - ${moment(lastDate).format('DD MMM YYYY')}`}
							</div>
						</div>

					</div>
				</h3>
			</div>
			<div
				style={{
					overflow: 'scroll',
					height: isLargeScreen ? '375px' : '100%',
				}}
				className="card-body py-5"
			>
				<div className="mb-5">
					<Link to="/usage/daily" className="fw-bold text-dark">
						{' '}
						<span className="fs-2hx text-end lh-1 ls-n2 counted">
							{currencyFormat(customerDashboard.latestUsage)}
						</span>
						<span className="fs-5">
							{' ' + renderUnit(customerDashboard.unit)}
						</span>
					</Link>
					<div className="text-muted fw-semibold fs-7 w-100 text-start">
						Latest usage
					</div>
				</div>
				<div className="d-flex justify-content-center w-100">
					<div className="d-flex gap-2 flex-wrap justify-content-around gap-3 w-100 align-items-center">
						<div>
							{loading ? (
								<span
									className="indicator-progress text-center"
									style={{ display: 'block' }}
								>
									Please wait...{' '}
									<span className="spinner-border spinner-border-sm align-middle"></span>
								</span>
							) : (
								<></>
							)}
							<div
								id="kt_card_widget_17_chart"
								ref={chartRef}
								style={{
									minWidth: chartSize + 'px',
									minHeight: chartSize + 'px',
								}}
								data-kt-size={chartSize}
								data-kt-line={chartLine}
							></div>

							<div className="w-100 text-center">
								<div className="fs-6 fw-semibold">

									{customerDashboard.percentage !== null ? `${currencyFormat(
										customerDashboard.percentage
									)}%` : '-'}
								</div>
								<div className="fs-7">Latest usage to maximum contract</div>
							</div>
						</div>

						<div className="mb-14 d-xl-block">

							{(!customerDashboard?.uom?.toLowerCase().includes('harian')) && (<div className="d-flex fw-semibold align-items-center">
								<div className="bullet w-8px h-3px rounded-2 bg-primary me-3"></div>
								<div className="flex-grow-1 me-4">
									<div className="text-gray-500">
										End-{uomPeriodLabel} estimated usage
									</div>
									<div className="fw-bolder text-dark">
										{`${currencyFormat(customerDashboard?.estimateUsage)} ${renderUnit(customerDashboard.unit)}`}
									</div>
								</div>
							</div>)}

							<Link
								to="/customer-profile/product/019616199"
								className="d-flex fw-semibold align-items-center my-3"
							>
								<div
									style={{ backgroundColor: '#00548b' }}
									className="bullet w-8px h-3px rounded-2 me-3"
								></div>
								<div className="flex-grow-1 me-4">
									<div className="text-gray-500">
										Minimum contract
									</div>
									<div className="fw-bolder text-dark">
										{
											customerDashboard.minimumContract !== null
												?
												`${currencyFormat(customerDashboard?.minimumContract)} ${renderUnit(customerDashboard?.unit)} /${uomPeriodLabel}`
												:
												'-'
										}
									</div>
								</div>
							</Link>
							<Link
								to="/customer-profile/product/019616199"
								className="d-flex fw-semibold align-items-center"
							>
								<div
									style={{ backgroundColor: '#ff000c' }}
									className="bullet w-8px h-3px rounded-2 me-3"
								></div>
								<div className="flex-grow-1 me-4">
									<div className="text-gray-500">
										Maximum contract
									</div>
									<div className="fw-bolder text-dark">
										{
											customerDashboard.maximumContract !== null
												?
												`${currencyFormat(customerDashboard.maximumContract)} ${renderUnit(customerDashboard.unit)} /${uomPeriodLabel}`
												:
												'-'
										}
									</div>
								</div>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const initChart = function (
	chartSize: number = 70,
	chartLine: number = 11,
	chartRotate: number = 0,
	statusColor: string = '',
	data?: any
) {
	const el = document.getElementById('kt_card_widget_17_chart');
	if (!el) {
		return;
	}
	el.innerHTML = '';

	var options = {
		size: chartSize,
		lineWidth: chartLine,
		rotate: chartRotate,
		//percent:  el.getAttribute('data-kt-percent') ,
	};

	const canvas = document.createElement('canvas');
	const span = document.createElement('span');

	// @ts-ignore
	if (typeof G_vmlCanvasManager !== 'undefined') {
		// @ts-ignore
		G_vmlCanvasManager.initElement(canvas);
	}

	const ctx = canvas.getContext('2d');
	canvas.width = canvas.height = options.size;

	el.appendChild(span);
	el.appendChild(canvas);

	// @ts-ignore
	ctx.translate(options.size / 2, options.size / 2); // change center
	// @ts-ignore
	ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI); // rotate -90 deg

	//imd = ctx.getImageData(0, 0, 240, 240);
	const radius = (options.size - options.lineWidth) / 2;

	const drawCircle = function (
		color: string,
		lineWidth: number,
		percent: number
	) {
		percent = Math.min(Math.max(0, percent || 1), 1);
		if (!ctx) {
			return;
		}

		ctx.beginPath();
		ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false);
		ctx.strokeStyle = color;
		ctx.lineCap = 'round'; // butt, round or square
		ctx.lineWidth = lineWidth;
		ctx.stroke();
	};

	// Init 2
	drawCircle('#E4E6EF', options.lineWidth, 100 / 100);
	// drawCircle(statusColor == 'badge-light-secondary' ? '#E4E6EF' : statusColor == 'badge-light-warning' ? '#00548b' : statusColor == 'badge-light-success' ? '#b0ca29' : '#ff000c', options.lineWidth, (statusColor === 'badge-light-secondary' ? 0 : statusColor == 'badge-light-warning' ? 20 : statusColor == 'badge-light-success' ? 80 : 160) / 150)
	// drawCircle(getCSSVariableValue('--bs-primary'), options.lineWidth, 100 / 250)
	drawCircle(
		statusColor == 'badge-light-secondary'
			? '#E4E6EF'
			: statusColor == 'badge-light-warning'
				? '#00548b'
				: statusColor == 'badge-light-success'
					? '#b0ca29'
					: '#ff000c',
		options.lineWidth,
		(data?.percentage ? data.percentage : 0) / 100
	);
};

export { MainChart };
